import {connect} from "react-redux"
import {SEO_METADATA_INCLUDE_COMPONENTS} from "../../config/constants"
import State from "../../models/State"

export const mapStateToProps = (state: State) => ({
    type: state.request.type,
    title: state.search.title,
    relaxedQuery: state.search.relaxedQuery,
    totalResults: state.search.totalResults,
    isAutocorrected: Boolean(state.search.autoCorrectQuery),
    originalSearchTerm: state.request.searchTerm,
    hasSelectedFilters: Object.values(state.search.facets).some(f => f.s),
    overrideHeading:
        (state.features.overrideSeo?.metadata &&
            state.search.includedComponents.includes(SEO_METADATA_INCLUDE_COMPONENTS)) ||
        state.request.isMerchandisedUrl ||
        false,
    text: state.text,
    enableCentreTitle: state.search.enableCentreTitle,
    templating: state.template,
})

export default connect(mapStateToProps)
